












import ErrorMessages from 'library/components/account/error-messages'
LS_KEY = 'purchasing subscription'
import { getCart } from 'library/store/cart'

# Make the component
export default

	components: { ErrorMessages }

	data: -> shouldRender: localStorage?.getItem LS_KEY

# Redirect to checkout after a user does gain a customer session
export returnToSubscriptionCheckout = ->

	# Check localStorage for the item we store if user was redirected during
	# an attempted checkout with subscriptions.
	isInCheckoutFlow = !!localStorage.getItem LS_KEY

	# After authing the user will either have been redirected to the homepage, if
	# they just created a customer, or to the /account page, if they already one.
	hasAuthed = location.pathname.match /^(\/|\/account)$/

	# A user now has a customer, so remove localStorage time and resume checkout
	if isInCheckoutFlow and hasAuthed
		# Get cart data so we can get the checkout URL
		cart = await getCart()
		checkoutUrl = cart.checkoutUrl

		localStorage.removeItem LS_KEY
		window.location = checkoutUrl

